module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-check-fill-0a19e0d6.svg";